import * as Sentry from "@sentry/react"

Sentry.init({
    dsn: "https://d6654e35d11bb322abb9409452271a60@o4509072121987072.ingest.de.sentry.io/4509288320532560",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
	environment: process.env.REACT_APP_CARDAMOMO_ENV,
  });
